import React, { Suspense } from 'react'
import Card from '../../../../../../components/Card'
import Body from './Body'
import List from './List'
import EditModel from './EditModal'
import useToggleState from 'src/hooks/useToggleState'
import { faCopy, faPencil, faTrash } from '@fortawesome/free-solid-svg-icons'
import DeleteModel from './DeleteModel'
import CopyModel from 'src/pages/cat/candidates/Candidate/cards/Details/CopyModal'

interface DetailsProps {
  id: string
}

const Details: React.FC<DetailsProps> = (props) => {
  const { id } = props
  const [isOpen, , handleToggle] = useToggleState()
  const [isDeleteOpen, , handleDeleteToggle] = useToggleState()
  const [isCopyOpen, , handleCopyToggle] = useToggleState()
  return (
    <>
      <Card
        title='Candidate'
        primaryAction={{
          key: 'edit-candidate-details',
          icon: faPencil,
          onClick: handleToggle,
          permissionKey: 'CAT_EDIT'
        }}
        secondaryActions={[
          {
            key: 'copy-candidate',
            onClick: handleCopyToggle,
            icon: faCopy,
            text: 'Copy',
            permissionKey: 'CAT_EDIT'
          },
          {
            key: 'delete-candidate',
            onClick: handleDeleteToggle,
            icon: faTrash,
            text: 'Delete',
            permissionKey: 'CAT_EDIT',
            iconProps: {
              className: 'text-danger'
            }
          }
        ]}
      >
        <Suspense fallback={<List candidate={undefined} />}>
          <Body id={id} />
        </Suspense>
      </Card>
      <EditModel id={id} isOpen={isOpen} toggle={handleToggle} />
      <DeleteModel id={id} isOpen={isDeleteOpen} toggle={handleDeleteToggle} />
      <CopyModel id={id} isOpen={isCopyOpen} toggle={handleCopyToggle} />
    </>
  )
}

export default Details
